export default class InventoryProductService {
  constructor(baseUri) {
    this.baseUri = baseUri
  }

  async create(inventoryTransaction, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction`, {
      body: JSON.stringify(inventoryTransaction),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'POST'
    })

    return await response.json()
  }

  async delete(id, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction/${id}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      },
      method: 'DELETE'
    })

    return response.ok
  }

  async find(id, options) {
    try {
      const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction/${id}`, {
        headers: {
          'Authorization': `Bearer ${options.accessToken}`
        }
      })

      return await response.json()
    } catch (e) {
      return null
    }
  }

  async getAll(options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async getAllForReceipt(receiptId, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction/receipt/${receiptId}`, {
      headers: {
        'Authorization': `Bearer ${options.accessToken}`
      }
    })

    return await response.json()
  }

  async update(id, inventoryTransaction, options) {
    const response = await fetch(`${this.baseUri}/inventoryManagement/inventoryTransaction/${id}`, {
      body: JSON.stringify(inventoryTransaction),
      headers: {
        'Authorization': `Bearer ${options.accessToken}`,
        'Content-Type': 'application/json'
      },
      method: 'PUT'
    })

    return response.ok
  }
}